<script lang="ts">
  import { onMount } from "svelte";
  let isOpen = false;
  export let admissions: any[] = [];
  export let selectedAdmission: string = "1";

  // Subscribe to store changes
  import { book, step } from "../../stores/WalkinBookingStore";

  book.subscribe(
    (value: { admissions?: any[]; admission?: string | number }) => {
      if (value?.admissions) {
        admissions = value.admissions;
      }
      if (value?.admission !== undefined) {
        // Ensure admission is always handled as a string
        selectedAdmission = String(value.admission);
      }
    }
  );

  const toggleDropdown = () => {
    isOpen = !isOpen;
  };

  const handleClickOutside = (event: MouseEvent) => {
    const target = event.target as HTMLElement;
    if (!target.closest(".custom-select")) {
      isOpen = false;
    }
  };

  $: selectedAdmissionName = selectedAdmission ? selectedAdmission : "1";

  const handleAdmissionChange = (e: any) => {
    const newAdmission = String(e.target.value);

    if (!newAdmission) return;

    selectedAdmission = newAdmission;
    isOpen = false;

    // Ensure store is updated with the new admission value
    book.update((value: any) => {
      const updatedValue = {
        ...value,
        admission: newAdmission,
        timeslot: "", // Reset timeslot when admission changes
        timeslots: [], // Reset timeslots array when admission changes
      };
      return updatedValue;
    });
  };

  const onNextStep = () => {
    // step.update((value) => value + 1);
    step.update((value) => {
      return value + 1;
    });
  };

  onMount(() => {
    // Ensure the initial state is set correctly
    selectedAdmission = "1";
    book.update((value) => ({
      ...value,
      admission: selectedAdmission,
    }));
  });
</script>

<svelte:window on:click={handleClickOutside} />

<div
  class="max-w-3xl w-full mx-auto relative mb-2 flex flex-col items-center justify-center"
>
  <div class="flex flex-col items-center justify-center mb-2">
    <h3
      class="text-lg font-semibold uppercase font-helveticaneue-bold-extended"
    >
      How many admissions?
    </h3>
    <p class="text-sm text-gray-600">
      Select how many guests are in your group.
    </p>
    <p class="text-sm text-gray-600 text-center">
      You will be charged 1 admission as your deposit. Any remaining
      admission(s) will be paid on site.
    </p>
  </div>
  <div class="w-full">
    <div class="custom-select relative w-full text-center">
      <div
        class="selected-value flex items-center justify-between px-4 py-4 border border-gray-300 rounded-lg cursor-pointer relative pl-6"
        on:click={toggleDropdown}
      >
        <span class="selected-text text-gray-700 w-full text-center uppercase">
          {selectedAdmissionName}
        </span>
        <svg
          class="w-4 h-4 text-gray-500 transform transition-transform {isOpen
            ? 'rotate-180'
            : ''}"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M19 9l-7 7-7-7"
          />
        </svg>
      </div>
      <ul
        class="options-list absolute w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-60 overflow-y-auto z-10 w-full text-center uppercase {isOpen
          ? ''
          : 'hidden'}"
      >
        {#if admissions && admissions.length > 0}
          {#each admissions as admission}
            <li
              class="px-4 py-4 hover:bg-gray-100 cursor-pointer text-center"
              data-value={String(admission)}
              on:click={() => {
                selectedAdmission = String(admission);
                handleAdmissionChange({ target: { value: String(admission) } });
              }}
            >
              {admission}
            </li>
          {/each}
        {/if}
      </ul>
    </div>
    <select
      bind:value={selectedAdmission}
      class="w-full text-center rounded-lg hidden"
      on:change={handleAdmissionChange}
    >
      <option value="">Select an Admission</option>
      {#if admissions && admissions.length > 0}
        {#each admissions as admission}
          <option value={String(admission)}>{admission}</option>
        {/each}
      {/if}
    </select>
  </div>
  <div class="mt-6 flex flex-row w-full">
    <div class="w-20">
      <button
        on:click={() => step.update((value) => value - 1)}
        class="text-xl focus:outline-none hover:text-brand transition ease-in-out bg-gray-200 text-gray-800 inline-block w-12 h-12 rounded-lg relative flex flex-col items-center justify-center"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-6 w-6 mx-auto"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M15 19l-7-7 7-7"
          />
        </svg>
      </button>
    </div>
    <div class="flex-1">
      <button
        on:click={onNextStep}
        class="w-full bg-black text-white px-4 py-2 rounded-lg text-2xl"
        >Next</button
      >
    </div>
  </div>
</div>

<style></style>
